<template>
    <div v-if="teacherAvailability">
        <b-breadcrumb>
            <b-breadcrumb-item to="/dashboard" active>{{$t('dasboard-teacher.card-price.dashboard')}}</b-breadcrumb-item>
                <template>
                    <!-- <b-breadcrumb-item>Profesores</b-breadcrumb-item> -->
                </template>
        </b-breadcrumb>
        <b-row v-if="availabilityClass && flagMostrarDashboard" class="section-card-dashboard">
            <b-col>
                <div class="card card-body card-availability mb-4">
                    <div class="d-flex justify-content-between">
                        <h6 class="sub-title"><span>{{$t('dasboard-teacher.card-price.titulo')}}</span></h6>
                        <h6 class="sub-title"><span>{{"$" + moneyBalance}}</span></h6>
                    </div>
                    <a href="/teacher/wallet" class="link"><span>{{$t('dasboard-teacher.card-price.button')}}</span></a>
                </div>

                <div class="card card-body card-availability mb-4">
                    <div class="card-title pb-4">
                        <h6 class="sub-title mb-0">
                            <span v-if="activeStudent > 0">{{activeStudent}} {{activeStudent == 1 ?  $t('dasboard-teacher.card-active.titulo') : $t('dasboard-teacher.card-active.titulo-plural')}}</span>
                            <span v-else>{{$t('dasboard-teacher.card-active.text-no-students')}}</span>
                        </h6>
                        <router-link :to="activeStudent > 0 ? '/chat': '/teacher/class-request'" >
                            <button v-if="activeStudent > 0" type="button" class="btn btn-primary">
                                <icon name="chat" class="mr-2" /> {{$t('dasboard-teacher.card-active.button-1')}}
                            </button>
                            <button v-else type="button" class="btn btn-primary">
                                <span class="material-icons-outlined mr-2"></span> {{$t('dasboard-teacher.card-active.button-no-students')}}
                            </button>
                        </router-link>
                    </div>
                    <h6 class="sub-title text-left mb-4"><span>{{$t('dasboard-teacher.card-active.titulo-2')}}</span></h6>
                    <div class="d-flex justify-content-between">
                        <img class="align-self-center" src="@/assets/img/girdRequest-2.png">
                        <div class="pl-4 w-75 ml-4" v-if="nextClass">
                    
                            <h6 class="d-flex align-items-center"><icon name="calendar" /><p>{{nextClass.startDate}}</p></h6>
                            <h6 class="d-flex align-items-center"><icon name="time" /><p>{{nextClass.time}}</p></h6>
                            <a href="#" @click="getNextClassData">
                                <icon v-if="nextClass.flagGroup" name="group" />
                                <icon v-else name="user-2" />
                                {{nextClass.detail}}
                            </a>
                             <!--<a href="#"><span class="material-icons-outlined">groups</span>{{$t('dasboard-teacher.card-active.text')}} {{$t('dasboard-teacher.card-active.text-1')}}</a>-->
                            <button   type="button" class="btn btn-primary mt-3"   :class="nextClass.linkClass != null? '': 'disabled'"  @click="openLinkClassLocal(nextClass.linkClass,$moment,nextClass.startDateValidate,nextClass.endDateValidate)">
                                <icon name="video" class="mr-2" />
                                {{$t('dasboard-teacher.card-active.button-2')}}
                            </button>
                            <!--v-b-modal.nextClass-->
                        </div>
                        <div class="pl-4 w-75 ml-4" v-else>
                            <h6 class="d-flex align-items-center">
                                <span class="spanSubTitle">There are no classes scheduled.</span>
                            </h6>
                        </div>

                    </div>
                </div>
            </b-col>
            <b-col>
                <div class="card card-body card-availability mb-4">
                    <h6 class="sub-title text-left mb-4"><span>{{$t('dasboard-teacher.card-available.titulo')}}</span></h6>
                    <div class="content-scroll pl-0" :class="[listClassesAvailables == null || listClassesAvailables.length == 0 && !flagAvailableClasses ? 'd-flex h-100 align-items-center justify-content-center':'']">
                        <div v-if="listClassesAvailables == null || listClassesAvailables.length == 0 && !flagAvailableClasses" class="card-title mb-3">
                            <icon name="alert" />
                            <span class="w-100">
                                <p>{{$t('dasboard-teacher.card-available.no-available-classes')}}</p>
                            </span>
                        </div>
                        <div v-else >
                            <div v-show="listClassesAvailables != null && listClassesAvailables.length != 0"   class="card-title mb-3" v-for="item in listClassesAvailables" :key="item.groupScheduleCounterProposalId" :id="'lstClassRequests'+item.groupScheduleCounterProposalId" >
                                <icon name="alert" />
                                <span class="w-100">
                                    <p v-if="item.flagGroup">{{$t('dasboard-teacher.card-available.text-direct-request-group',{GroupName:item.code})}}</p>
                                    <p v-else>{{$t('dasboard-teacher.card-available.text-direct-request',{StudentName:item.persons ? item.persons.strFullName : ''})}}</p>
                                    <a href="/teacher/class-request/private" class="link"><span>{{$t('dasboard-teacher.card-available.button')}}</span></a>
                                </span>
                            </div>
                            <div v-show="listClassesAvailables == null || listClassesAvailables.length == 0" class="card-title mb-3" >
                                <icon name="alert" />
                                <span class="w-100">
                                    <p>{{$t('dasboard-teacher.card-available.no-available-direct-requests')}}</p>
                                </span>
                            </div>


                            <div class="card-title mb-3" v-if="flagAvailableClasses">
                                <icon name="alert" />
                                <span class="w-100">
                                    <p>{{$t('dasboard-teacher.card-available.new-students-available')}}</p>
                                    <a href="/teacher/class-request/public" class="link"><span>{{$t('dasboard-teacher.card-available.button')}}</span></a>
                                </span>
                            </div>

                        </div>
                        

                        
                        
                    </div>
                </div>

                <div class="card card-body card-availability mb-4 card-mid">
                    <h6 class="sub-title text-left mb-4"><span>{{$t('dasboard-teacher.card-cancelaciones.titulo')}}</span></h6>
                    <div v-if="classesCancelled && classesCancelled.length != 0">
                        <div class="content-scroll cancellations pl-0">
                            <div class="card-title mb-3" v-for="item in classesCancelled" :key="item.id" :id="'class_cancelled_' + item.id">
                                <icon name="alert-2" />
                                <span class="w-100">
                                    <p v-if="item.flagGroup">{{$t('dasboard-teacher.card-cancelaciones.text-group', {GroupName:item.code, Date:item.strStartDate_EN, Hour:item.strStartEndDate.split("-")[0]})}}</p>
                                    <p v-else>{{$t('dasboard-teacher.card-cancelaciones.text',{StudentName:item.persons.strFullName ? item.persons.strFullName : "", Date:item.strStartDate_EN, Hour:item.strStartEndDate.split("-")[0]})}}</p>

                                    <a href="#" class="link" @click="getWeekSchedule(item.id, item.startDate)"><span>{{$t('dasboard-teacher.card-cancelaciones.button')}}</span></a>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div v-else class="h-100 d-flex align-items-center justify-content-center"> 
                        There are currently no cancellations.
                    </div>
                </div>
            </b-col>
        </b-row>
        <div v-if="!availabilityClass && flagMostrarDashboard" class="card card-body card-availability update" style="padding-left: calc(50% - 400px)">
            <div class="text-center" style="max-width:400px">
                <img class="mb-4" src="@/assets/img/circle-calendar.png" alt="">
                <h6 class="sub-title text-left mb-5"><span class="text-center">Please update your availability in order to start taking classes.</span></h6>
                 <router-link to="/teacher/schedule" >
                    <button type="button" class="btn btn-primary d-flex m-auto">
                        <icon name="calendar" class="mr-2" />
                        Update availability
                    </button>
                 </router-link>
            </div>
            <img src="@/assets/img/calendar2.png" class="personCalendar">
        </div>
        <b-modal id="nextClass"
            :hide-footer="true" 
            :hide-header="true" 
            :centered="true">
            <h6 class="sub-title"><span>{{$t('dasboard-teacher.modal-next-class.titulo')}}</span></h6>
            <img class="close" src="@/assets/img/close_red.png" @click="$bvModal.hide('nextClass')">
            <b-row v-if="nextClassDetail">
                <b-col cols="7">
                    <div class="d-flex mb-4">
                        <img src="@/assets/img/girdRequest-2.png">
                        <div class="pl-5">
                            <b v-if="nextClassDetail.groupCode">{{$t('dasboard-teacher.modal-next-class.sub-titulo')}}</b>
                            <p v-if="nextClassDetail.groupCode">{{nextClassDetail.groupCode}}</p>

                            <b>{{$t('dasboard-teacher.modal-next-class.sub-titulo-2')}}</b>
                            <p v-if="nextClassDetail.levels != null">{{nextClassDetail.levels.abbreviation}} {{nextClassDetail.levels.name}}</p>
                        </div>
                    </div>
                    <div v-if="nextClass.flagPlanTest" class="d-flex mb-4">
                        <span class="material-icons-outlined">bookmark</span>
                        <b>{{$t('reusables.test-class')}}</b>
                    </div>
                    <b>{{$t('dasboard-teacher.modal-next-class.sub-titulo-3')}} </b>
                    <ul class="mt-3 list-ul">
                        <li v-for="(item, i) in nextClassDetail.subjects" :key="i" :id="'subject_'+i">
                            {{item.name_EN}}
                        </li>
                    </ul>
                    
                    
                     
                </b-col>
                <b-col cols="5" class="pl-0">
                    <div class="list-class">
                        <b>{{$t('dasboard-teacher.modal-next-class.sub-titulo-4')}} </b>
                        <ul class="mt-3 list-ul">
                            <li v-for="(item, i) in nextClassDetail.persons" :key="i" :id="'subject_'+i">
                                {{item.strFullName}}
                            </li>
                        </ul>
                    </div>
                </b-col>
            </b-row>
            <div class="mt-3">
                <button type="button" class="btn btn-primary d-block m-auto" :class="nextClass && nextClass.linkClass != null? '': 'disabled'"  @click="openLinkClassLocal(nextClass.linkClass,$moment,nextClass.startDateValidate,nextClass.endDateValidate)">
                     <icon name="video" /> {{$t('dasboard-teacher.modal-next-class.button')}}</button>
            </div>
        </b-modal>
        <ModalCalendarWeekTeacher :calendarEvents="calendarEvents"/>
        <b-modal id="modal-next-linkClass" :centered="true">
            <template #modal-header="{ close }">
              <img class="close" src="@/assets/img/close_red.png" @click="close()">
            </template>
            <p class="text-center mb-0" >{{ messageLinkClassResult }}</p>
            <template #modal-footer>
                <b-button @click="$bvModal.hide('modal-next-linkClass')" variant="primary">Accept</b-button>
          </template>
		</b-modal>
	
    </div>
</template>
<script>
import ModalCalendarWeekTeacher from '@/components/modals/modalCalendarDemo'
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import * as Constants from "@/assets/js/appConstants";
import { horarioObtenerColorClase, openLinkClass, convertToUserTimeCalendarEvents, getNextClassDate,getNextClassTime, convertTimeToUserTimeFormat } from '@/assets/js/util.js';
import {mapState} from "vuex";
export default {
    data(){
        return{
            API_URL: process.env.VUE_APP_API_URL,
            teacherAvailability:true, //false
            availabilityClass:true, //false
            messageLinkClassResult:null,
            levels: [],
            subjects:[],
            groupsPlan:null,
            flagMostrarDashboard:false,
            teacher:null,
            nextClass:null,
            nextClassDetail:null,
            classesCancelled:null,
            listClassesAvailables:null,
            flagAvailableClasses:false,
            activeStudent: 0,
            moneyBalance:0,
            calendarEvents:null,
            openLinkClass:openLinkClass
            //typeScheduleTeacher: {'TeacherSchedule': 1, 'StudentSchedule': 2}
        }
    },
    components:{
        ModalCalendarWeekTeacher
    },
    computed: {
        ...mapState(['flag_subject','flagPostulant']),
        flag_subject: {
            get() {
                return this.$store.state.flag_subject;
            },
        },
        User: {
            get() {
                return this.$store.state.user;
            },
        }
    },
	mounted: function () {
		this.getDashboardData();

        
	},
    methods: {
		getDashboardData: function() {
            //debugger;
            baseInstanceAxios
                .get(this.API_URL + `/resources/dashboard/GetTeacherConsolidatedById?personTeacherId=${this.User.personTeacherId}` )
                .then(response => {
                    if(response.data != null && response.data.entity != null){
                        let entity = response.data.entity;
                        
                        this.activeStudent = entity.activeStudent;
                        this.moneyBalance = entity.myBalanceStr;
                        
                        let format_time_validate = "YYYY-MM-DDTHH:mm:ss";
                        let format_day = "MM/DD/YYYY";
                        let format_time = "h:mm a";

                        if(entity.teacherScheduleClass){

                            

                            this.nextClass = {
                                //startDate: entity.teacherScheduleClass.strStartDate_EN,
                                //time: entity.teacherScheduleClass.strStartEndDate,
                                startDate: getNextClassDate(entity.teacherScheduleClass.startDate, this.$store.state.user.timeZoneName, this.$moment, format_day),
                                time: getNextClassTime(entity.teacherScheduleClass.startDate, entity.teacherScheduleClass.endDate, this.$store.state.user.timeZoneName, this.$moment, format_time),
                                flagGroup: entity.teacherScheduleClass.flagGroup,
                                id: entity.teacherScheduleClass.id,
                                groupId: entity.teacherScheduleClass.groupId,
                                groupCode: entity.teacherScheduleClass.code,
                                linkClass: entity.teacherScheduleClass.linkClass,
                                flagPlanTest: entity.teacherScheduleClass.groupScheduleStudents.flagPlanTest,
                                //startDateValidate: entity.teacherScheduleClass.startDate,
                                //endDateValidate: entity.teacherScheduleClass.endDate,  
                                startDateValidate: convertTimeToUserTimeFormat(response.data.entity.teacherScheduleClass.startDate, this.$store.state.user.timeZoneName, this.$moment, format_time_validate)  ,
                                endDateValidate: convertTimeToUserTimeFormat(response.data.entity.teacherScheduleClass.endDate, this.$store.state.user.timeZoneName, this.$moment, format_time_validate)   ,
                        }
 
                            if(this.nextClass.flagGroup){
                                this.nextClass.detail = this.$t('dasboard-teacher.card-active.text',{totalStudents: entity.teacherScheduleClass.groupQuantity});  
                                //this.nextClass.detail = this.$t('error.2')+`${entity.teacherScheduleClass.groupQuantity}`+this.$t('error.2-2');
                            }
                            else{
                                this.nextClass.detail = entity.teacherScheduleClass.persons.strFullName;
                            }

                        }

                        this.classesCancelled = entity.listTeacherScheduleCanceled;
                        if(this.classesCancelled .length != 0){

                            this.classesCancelled.forEach(element => {
                                element.strStartDate_EN = getNextClassDate(element.startDate, this.$store.state.user.timeZoneName, this.$moment, format_day);
                                element.strStartEndDate = getNextClassTime(element.startDate, element.endDate, this.$store.state.user.timeZoneName, this.$moment, format_time);
                                element.strStartTime = element.strStartEndDate.split("-")[0].trim();
                            });
                        }

                        this.listClassesAvailables = entity.listClassAvality;
                        this.flagAvailableClasses = entity.flagAvalilableClass;
                    }
                    else{
                        this.availabilityClass = false;
                    }
                    this.flagMostrarDashboard = true;
                });
        },
		getNextClassData: function(){
            
            let data = {
                Id: this.nextClass.id,
                GroupId: this.nextClass.groupId,
                FlagGroup: this.nextClass.flagGroup,
                
            }
            
            baseInstanceAxios
                .post(this.API_URL + `/resources/dashboard/GetDataNextClassTeacher`, data)
                .then(response => {
                    if(response.data != null && response.data.entity != null){
                        let entity = response.data.entity;
                        
                        this.nextClassDetail = {
                            groupCode: this.nextClass.flagGroup ? this.nextClass.groupCode : entity.groupCode,
                            levels: entity.levels,
                            persons: entity.persons,
                            subjects: entity.subjects
                        }
                        
                        this.$bvModal.show('nextClass');
                    }
                });
             
        },
       
        getWeekSchedule: function(id, date) {
            this.$bvModal.show('modalCalendarWeek');
            this.calendarEvents = [];
            baseInstanceAxios
                //.get(this.API_URL + `/resources/Dashboard/GetWeekScheduleTeacher?scheduleId=${id}`)
                .get(`${this.apiURL}/resources/PersonsTeachers/GetDashboardScheduleWithDateByTeacher?PersonTeacherId=${this.$store.state.user.personTeacherId}&date=${date}&timeZoneName=${this.$store.state.user.timeZoneName}`)
                .then(response => {
                    if(response.data != null && response.data.entity != null){
                        //let arrayHours = convertToUserTimeCalendarEvents(response.data.entity.scheduleDetail, this.$store.state.user.timeZoneName, this.$moment );

                        this.calendarEvents = response.data.entity.scheduleDetail.map(element => (
                            {   
                                id: element.id, 
                                description: "",
                                start: element.startDate,
                                end: element.endDate,
                                flagUpdate: element.flagUpdate,
                                title: element.typeOfSchedule == Constants.TYPE_SCHEDULE.TEACHER ? this.$t('reusables.unavailable') :  (element.className + (element.flagPlanTest ? " | " + this.$t('reusables.test-class') : "") || "clase"),
                                editable: false,
                                //color: horarioObtenerColorClase(item.stateClass.value),
                                color: element.typeOfSchedule == Constants.TYPE_SCHEDULE.TEACHER ? Constants.CALENDAR_STATUS.UNAVAILABLE.COLOR: horarioObtenerColorClase(element.stateClass.value),
                                groupid: element.groupId,
                                typeOfSchedule: element.typeOfSchedule,
                                personName: element.className,
                                flagPlanTest:element.flagPlanTest,
                                subjectsName: element.subjectsName_EN,
                                //stateClass: element.stateClass,
                                stateClass: element.stateClass,
                                scheduleId: element.id,
                                //linkClass: element.linkClass,
                                //personName: item.flagGroup ? `Grupo ${item.code}` : item.personsStudents.person.strFullName,
                                
                                titleCourse: element.subjectsName_EN,
                            })
                        );
 
                        
                    }
                }); 
        },
        openLinkClassLocal(linkClass,moment,startDate,endDate){
             this.messageLinkClassResult = null;
             let result = openLinkClass(linkClass,moment,startDate,endDate,this.$store.state.user.timeZoneName);
             if(result!=""){
               this.messageLinkClassResult = result;
               this.$bvModal.show("modal-next-linkClass");
            }
        }, 
	}
}
</script>